/**
 * Names for the `data-cls-region` markers read by `lib/webVitals/reportCls`.
 *
 * These strings reach PostHog verbatim as `shift_region`, so renaming one
 * splits its series in the field data. Treat them as an external contract, not
 * as internal identifiers.
 *
 * The marker must sit on the element a component owns, never be passed in as a
 * prop from the caller: the store-page components destructure their props and
 * do not spread the rest, so a `data-*` arriving from outside is dropped with
 * no error and the whole collection comes back null.
 */
const CLS_REGIONS = {
  ABOUT: 'store-about',
  EXPIRED_COUPONS: 'store-expired-coupons',
  FAQ: 'store-faq',
  TIMELINE_NAV: 'store-timeline-nav',
  VERIFICATION_CARD: 'store-verification-card',
};

export default CLS_REGIONS;
